import { Component, OnInit } from '@angular/core';

import { TemplateService, TemplatesTypes } from '../template-popup/template.service';

/** This component displays the application footer */
@Component({
    selector: 'cw-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false,
})
export class FooterComponent implements OnInit {
    year?: number;

    templateTypes = TemplatesTypes;

    constructor(public templateService: TemplateService) {}

    ngOnInit(): void {
        this.year = new Date().getFullYear();
    }
}
